(() => {
  const widget = document.getElementById('az_reviews');
  const template = document.querySelector('[data-sf-review-summary-template]');
  const labelsNode = document.querySelector('[data-sf-review-summary-labels]');
  if (!widget || !template || !labelsNode || widget.dataset.sfSummaryInitialized) return;
  widget.dataset.sfSummaryInitialized = 'true';
  const labels = JSON.parse(labelsNode.textContent);
  const locale = document.documentElement.lang || 'pt-BR';
  const formatRating = new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  const formatCount = new Intl.NumberFormat(locale);
  let queued = false;

  function setText(element, text) {
    if (element.textContent !== text) element.textContent = text;
  }

  function update() {
    queued = false;
    const nativeWrite = widget.querySelector('.write_review_button');
    const ratingNode = widget.querySelector('.average_rating .box_rating4_average') || widget.querySelector('.arv-dd-score');
    const countNode = widget.querySelector('.AreviewsTotalNumber');
    const rating = Number(ratingNode?.textContent.trim().replace(',', '.'));
    const countText = countNode?.textContent.trim() || '';
    const count = Number(countText.replace(/\D/g, ''));
    const valid = nativeWrite && ratingNode && countNode && Number.isFinite(rating) && rating >= 0 && rating <= 5 && count > 0;
    widget.classList.toggle('sf-review-summary-ready', Boolean(valid));
    let bar = widget.querySelector('.sf-review-summary');
    if (!valid) { if (bar) bar.hidden = true; widget.classList.remove('sf-review-filters-open'); return; }
    if (!bar) {
      bar = template.content.firstElementChild.cloneNode(true);
      const heading = widget.querySelector('.reviews_main_title_container, .box_rating_container_style2');
      if (!heading) return;
      heading.before(bar);
      bar.querySelector('[data-sf-review-write-native]').addEventListener('click', () => {
        const button = widget.querySelector('.write_review_button');
        if (button && !button.disabled) button.click();
      });
      bar.querySelectorAll('[data-sf-review-filter-toggle]').forEach(button => button.addEventListener('click', () => {
        const open = widget.classList.toggle('sf-review-filters-open');
        bar.querySelectorAll('[data-sf-review-filter-toggle]').forEach(trigger => trigger.setAttribute('aria-expanded', String(open)));
      }));
    }
    const panel = widget.querySelector('.box_rating_container_style2');
    if (panel) {
      panel.id ||= `sf-reviews-filter-${widget.dataset.product_id}`;
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-label', labels.filters);
      bar.querySelectorAll('[data-sf-review-filter-toggle]').forEach(trigger => {
        trigger.setAttribute('aria-controls', panel.id);
        trigger.setAttribute('aria-expanded', String(widget.classList.contains('sf-review-filters-open')));
      });
    }
    bar.hidden = false;
    setText(bar.querySelector('[data-sf-review-score]'), `${formatRating.format(rating)}/5`);
    setText(bar.querySelector('[data-sf-review-count]'), `${formatCount.format(count)} ${count === 1 ? labels.one : labels.many}`);
    bar.querySelector('.sf-review-summary__stars').setAttribute('aria-label', `${labels.rating}: ${formatRating.format(rating)}/5`);
    bar.querySelector('.sf-review-summary__details').title = `${labels.rating}: ${formatRating.format(rating)}/5`;
    const stars = bar.querySelector('.sf-review-summary__stars');
    const width = `${rating * 20}%`;
    if (stars.style.getPropertyValue('--sf-review-fill') !== width) stars.style.setProperty('--sf-review-fill', width);
  }

  new MutationObserver(() => {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }).observe(widget, { childList: true, subtree: true, characterData: true });
  update();
})();
